import { Textarea } from '@ember/component';
import { on } from '@ember/modifier';
import { action } from '@ember/object';

import didInsert from 'webapp/modifiers/did-insert';
import type { Args as BaseArgs } from 'webapp/components/form/text-base';
import FormTextBaseComponent from 'webapp/components/form/text-base';

interface Args extends BaseArgs {
	newlineOnlyWithShift?: boolean;
	selectAllOnClick?: boolean;
}

export default class FormTextareaComponent extends FormTextBaseComponent<Args> {
	@action
	override keyDown(e: KeyboardEvent) {
		const pressedEnter = e.key === 'Enter',
			pressedShift = e.shiftKey;
		if (!pressedEnter || !pressedShift || !this.args.newlineOnlyWithShift) {
			super.keyDown(e);
		}
	}

	@action
	click(e: PointerEvent) {
		if (this.args.selectAllOnClick) {
			const node = e.target as HTMLInputElement;
			if (node) {
				node.select();
			}
		}
	}
	<template>
		<Textarea
			class="{{this.themeClass}} {{this.sizeClass}}"
			autocomplete="off"
			...attributes
			{{! @glint-expect-error: @value is two-way bound to the caller's property, which can be a number; Glint types Input @value as string }}
			@value={{@value}}
			@insert-newline={{this.insertNewline}}
			{{didInsert this.setupView}}
			{{on "input" this.input}}
			{{on "focusin" this.focusIn}}
			{{on "focusout" this.focusOut}}
			{{on "keydown" this.keyDown}}
			{{on "click" this.click}}
		/>
	</template>
}
